import { useAtomCallback } from 'jotai/utils';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { updateList } from '../../../../../services/queries/MaggieListQueries';
import { useToastMessageState } from '../../../../ToastMessage/ToastMessageProvider';
import { activeCompanyListIdStateJ, listsStateJ } from '../../../../../services/state/ListsStateJ';

export const useSetArchiveDateOnList = (numOfDays: number | null): (() => Promise<void>) => {
  const { pushErrorToast } = useToastMessageState();
  const listId = useAtomValue(activeCompanyListIdStateJ);

  return useAtomCallback(
    useCallback(
      async (get, set) => {
        try {
          if (listId === null) {
            throw new Error('No list id provided');
          }

          let archiveDate: Date | null = new Date();

          if (numOfDays) {
            archiveDate.setDate(archiveDate.getDate() + numOfDays);
          }

          if (numOfDays == null) {
            archiveDate = null;
          }

          const updatedList = await updateList({ archiveDate }, listId);

          const currVal = await get(listsStateJ);
          if (currVal) {
            set(
              listsStateJ,
              currVal.map((item) => (item.id === listId ? updatedList : item))
            );
          }
        } catch {
          pushErrorToast({ message: 'An error occurred while trying to delete the list.' });
        }
      },
      [listId, numOfDays, pushErrorToast]
    )
  );
};
